export default {
  sihuaLu: '祿',
  sihuaQuan: '權',
  sihuaKe: '科',
  sihuaJi: '忌',
} as const;
